fx.ns("shared.renderers", class TextRenderer extends fx.Component{
    
	constructor(data)
	{
		super(data);
	}

	render()
	{
        return '<img class="draggable" data-behaviour="add-component" data-class="Text" src="' + this.data.thumb + '" data-id="' + this.data.id + '" data-width="' + this.data.text_width + '" data-height="' + this.data.text_height + '" >';
	}

	
});
